import { render } from "./TripDetailsView.vue?vue&type=template&id=e493b18c&scoped=true"
import script from "./TripDetailsView.vue?vue&type=script&lang=ts"
export * from "./TripDetailsView.vue?vue&type=script&lang=ts"

import "./TripDetailsView.vue?vue&type=style&index=0&id=e493b18c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e493b18c"

export default script